// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultFilters_wrapper__1MdgP"};